/* eslint-disable no-debugger */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { push } from "connected-react-router";
import { useDispatch } from "react-redux";
import { PatrimonialRightsConnect } from "../../services/patrimonial-rights";
import { OverduePatrimonialRightsConnect } from "../../services/overdue-patrimonial-rights";
import {
  PageTitle,
  PageSubtitle,
  Name,
  SubtitleContainer,
  PaymentListContainer,
  MainContainer,
  Placeholder,
  PlaceholderMessage,
  PlaceholderImage,
  PlaceholderLink,
  ImgContainer,
  Container,
  BackButton,
  BackButtonImage,
  BackContainer,
  BackgrountImage
} from "./styles";

import { Loader } from "@bvcco/a2censo-component-lib";

import {
  usePaymentData,
  usePaymentActions,
  useEqualHeight,
  useSystemParameters
} from "./hooks";
import PaymentCard from "./components/PaymentCard";
import ApprovalModal from "./components/ApprovalModal";
import PaymentsActions from "../../redux/reducers/payments.reducer";

const MyPayments2 = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    pendingPayments,
    payments,
    isLoading,
    userName,
    processedPayments
  } = usePaymentData();

  const {
    getNumericValue,
    isLoading: isLoadingParameters
  } = useSystemParameters();

  // Estado para el flujo de aprobar is_approved via ACC
  const {
    isApprovingIssuerPayment,
    approveIssuerPaymentError,
    isIssuerPaymentApproved
  } = useSelector(({ payments: paymentsState }) => paymentsState);

  const {
    handleClickPay,
    handleDownloadExcel,
    handleApprovePayment,
    handleClickLink,
    handleBack
  } = usePaymentActions();

  // Hook para igualar altura de headers en la misma fila
  useEqualHeight("#payment-list-container", ".payment-card-header", [
    processedPayments
  ]);

  const [approvalModalData, setApprovalModalData] = useState(null);
  const [waitingForApproval, setWaitingForApproval] = useState(false);

  const userInfo = useSelector((state) => state.user.userInfo?.user);

  useEffect(() => {
    if (isIssuerPaymentApproved && waitingForApproval && approvalModalData) {
      const { issuerPayment, campaignId, isOverdue, overdueTotal, paymentData } = approvalModalData;

      // Fire & forget: generar Excel de derechos patrimoniales en S3
      if (!issuerPayment.equity_rights_url) {
        const payload = {
          campaignId,
          userId: userInfo?.id || null,
          userEmail: userInfo?.email || "",
          issuerPaymentID: issuerPayment.id
        };
        const service = isOverdue
          ? new OverduePatrimonialRightsConnect()
          : new PatrimonialRightsConnect();
        const apiCall = isOverdue
          ? service.getOverduePatrimonialRightsReport(payload)
          : service.getPatrimonialRightsReport(payload);
        apiCall.catch(() => {});
      }

      setApprovalModalData(null);
      setWaitingForApproval(false);

      // Configurar campaña seleccionada y navegar a confirmación de pago
      // Se hace AQUÍ (después de aprobar) para evitar que el epic de
      // setCampaignSelected navegue antes de que la aprobación termine.
      handleClickPay(
        campaignId,
        { ...issuerPayment, is_approved: true },
        isOverdue,
        overdueTotal,
        paymentData
      );
    }
  }, [
    isIssuerPaymentApproved,
    waitingForApproval,
    approvalModalData,
    dispatch,
    userInfo,
    handleClickPay
  ]);

  useEffect(() => {
    if (approveIssuerPaymentError && waitingForApproval) {
      setWaitingForApproval(false);
    }
  }, [approveIssuerPaymentError, waitingForApproval]);

  /**
   * Maneja la solicitud de pago
   * Si is_approved es false o undefined: Abre el modal de confirmación
   * Si is_approved es true: Va directo a pagar
   */
  const handlePayRequest = (
    campaignId,
    issuerPayment,
    isOverdue,
    overdueTotal,
    paymentData
  ) => {
    dispatch(PaymentsActions.clearApproveIssuerPaymentState());

    if (issuerPayment.is_approved === true) {
      handleClickPay(
        campaignId,
        issuerPayment,
        isOverdue,
        overdueTotal,
        paymentData
      );
      return;
    }

    const { amount } = paymentData;
    const campaignName =
      pendingPayments.find((p) => p.campaign_id === campaignId)?.name || "";

    setApprovalModalData({
      issuerPaymentId: issuerPayment.id,
      campaignName,
      amount,
      campaignId,
      issuerPayment,
      isOverdue,
      overdueTotal,
      paymentData
    });
  };

  /**
   * Cierra el modal de confirmación
   */
  const handleCloseModal = () => {
    setApprovalModalData(null);
    setWaitingForApproval(false);
  };

  /**
   * Confirma el pago y ejecuta la acción
   * Para pagos con is_approved = false:
   * 1. Configura la campaña seleccionada
   * 2. Despacha la acción approvePayment al epic
   * 3. El epic actualiza is_approved=true y emite success
   * 4. El useEffect detecta el success y navega a /confirm-pay-amount
   *
   * Para pagos con is_approved = true:
   * - Usa el flujo normal de pago
   */
  const handleConfirmPayment = (issuerPaymentId) => {
    if (!approvalModalData) {
      return;
    }

    const {
      campaignId,
      issuerPayment,
      isOverdue,
      overdueTotal,
      paymentData
    } = approvalModalData;

    if (!issuerPayment.is_approved) {
      setWaitingForApproval(true);
      handleApprovePayment(issuerPaymentId);
    } else {
      handleClickPay(
        campaignId,
        issuerPayment,
        isOverdue,
        overdueTotal,
        paymentData
      );
      setApprovalModalData(null);
    }
  };

  if (isLoading || isLoadingParameters) {
    return (
      <div
        style={{
          height: "90vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Loader />
      </div>
    );
  }

  const minimumLatePaymentAmount = getNumericValue(
    "minimum_amount_late_payment",
    10000
  );

  return (
    <MainContainer>
      <Container>
        <BackContainer>
          <BackButton data-testid="back-button" onClick={handleBack}>
            <BackButtonImage alt="previous" src="/assets/images/previous.png" />
          </BackButton>
        </BackContainer>

        <PageTitle>{t("myPayments.title")}</PageTitle>

        <SubtitleContainer>
          <PageSubtitle>
            <Name>{userName}</Name>
            {t("myPayments.subtitle")}
            <PlaceholderLink
              data-testid="history-link"
              disabled={pendingPayments.length === 0 && payments.length === 0}
              onClick={handleClickLink}
            >
              {t("myPayments.link")}
            </PlaceholderLink>
          </PageSubtitle>
        </SubtitleContainer>

        {/* Mostrar tarjetas de pago */}
        {!isLoading && pendingPayments.length > 0 && (
          <PaymentListContainer>
            {processedPayments.map((paymentData) => {
              const {
                id,
                campaign,
                issuerPayment,
                isOverdue,
                overdueTotal,
                dateExpiration,
                businessDaysToPay,
                transactionStatus,
                transactionStatusLabel,
                isPaymentCompleted,
                isPartialPayment,
                netAmount
              } = paymentData;

              return (
                <PaymentCard
                  key={id}
                  campaign={campaign}
                  issuerPayment={issuerPayment}
                  netAmount={netAmount}
                  isOverdue={isOverdue}
                  overdueTotal={overdueTotal}
                  dateExpiration={dateExpiration}
                  businessDaysToPay={businessDaysToPay}
                  transactionStatus={transactionStatus}
                  transactionStatusLabel={transactionStatusLabel}
                  isEmpty={isPaymentCompleted}
                  isPartialPayment={isPartialPayment}
                  minimumLatePaymentAmount={minimumLatePaymentAmount}
                  onPay={(paymentDataCallback) => {
                    handlePayRequest(
                      campaign.campaign_id,
                      issuerPayment,
                      isOverdue,
                      overdueTotal,
                      paymentDataCallback
                    );
                  }}
                  onDownloadExcel={handleDownloadExcel}
                />
              );
            })}
          </PaymentListContainer>
        )}

        {/* Estado vacío - Sin pagos pendientes */}
        {!isLoading && pendingPayments.length === 0 && (
          <PaymentListContainer>
            <Placeholder>
              <ImgContainer>
                <BackgrountImage>
                  <PlaceholderImage
                    alt="money"
                    src="/assets/images/icono_dinero.png"
                  />
                </BackgrountImage>
              </ImgContainer>
              <PlaceholderMessage>
                {t("myPayments.noPendingPayments")}
              </PlaceholderMessage>
            </Placeholder>
          </PaymentListContainer>
        )}
      </Container>

      {/* Modal de confirmación de pago */}
      <ApprovalModal
        data={approvalModalData}
        isLoading={isApprovingIssuerPayment}
        error={approveIssuerPaymentError}
        onClose={handleCloseModal}
        onConfirm={handleConfirmPayment}
      />
    </MainContainer>
  );
};

export default MyPayments2;
